<template>
  <el-dialog
    :visible="videoVisible"
    :show-close="true"
    width="670px"
    @close="closeVideo"
    append-to-body
  >
    <video
      ref="videoRef"
      width="100%"
      height="400px"
      controls
      :src="url"
      style="display: block; background-color: black"
    ></video>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      url:'',
      videoVisible: false,
    };
  },
  created() {},
  computed: {},
  methods: {
    showVideo(url) {
      this.url = url
      this.videoVisible = true;
      this.$emit("showVideo");
    },
    closeVideo() {
      this.videoVisible = false;
      this.$emit("closeVideo");
      // 停止播放并重置视频
      this.$nextTick(() => {
        const video = this.$refs.videoRef;
        if (video) {
          video.pause();
          video.currentTime = 0; // 重置播放进度
        }
      });
       this.url =""
    },
  },
};
</script>

<style scoped lang="scss"></style>
